export const REASONS = [
	"I want to learn what it's like to have a startup and be an entrepreneur.",
	'I want to make my resume/college application stronger.',
	'I want to meet like-minded people to network and make friends with.',
	'I want to make my parents happy.',
	"I have a business idea, and I don't know where or how to start.",
	'I want to have a fun summer experience.',
	'I want to find cofounders for my idea.',
] as const

export const ENTREPRENEURIAL_TYPES = ['Brander', 'Brain', 'Builder', 'Business Developer'] as const

export const HEAR_ABOUT = [
	'Google Search',
	'Social Media',
	'Leangap alumni or mentor',
	'Friend or family member',
	'College counselor',
	'Blog post or online article',
	'Other',
] as const

export const SOCIAL_MEDIA_PLATFORMS = [
	'Instagram',
	'Facebook',
	'YouTube',
	'Snapchat',
	'TikTok',
] as const

export const EXTRA_LABELS: Record<string, string> = {
	'Leangap alumni or mentor': 'Name of the alumni or mentor*',
	'College counselor': 'Which organization does your college counselor work for?*',
	'Friend or family member': 'Name of friend/family*',
	Other: 'Mention the specific source*',
}

export const NEEDS_EXTRA_KEYS: string[] = [
	'Social Media',
	'Leangap alumni or mentor',
	'Friend or family member',
	'College counselor',
	'Other',
]
